var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewModusSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view_modus1Element 137") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie",
    "data-name": "Isolationsmodus Kopie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V55H55V0ZM52.73552,18.2176H36.7824V2.26448H52.73552Zm-33.211,17.25785V20.48209H34.51791V35.47545Zm14.99336,2.26449V52.73552H19.52455V37.73994ZM17.26006,35.47545H2.26448V20.48209H17.26006ZM19.52455,18.2176V2.26448H34.51791V18.2176ZM36.7824,20.48209H52.73552V35.47545H36.7824ZM17.26006,2.26448V18.2176H2.26448V2.26448ZM2.26448,37.73994H17.26006V52.73552H2.26448ZM36.7824,52.73552V37.73994H52.73552V52.73552Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModusSmall);
export default __webpack_public_path__ + "static/media/view_modus_small.7cdf238573eb9b230b085062234a3ae0.svg";
export { ForwardRef as ReactComponent };